export default __webpack_public_path__ + "static/media/failed.924ec296.svg";